import request from '@/utils/request'
// 获取当前系统下研报列表
export const findSystemReports = params => {
    return request({
        method: 'POST',
        url: '/graphicallightweightdata/ms/findSystemReports',
        data: params
    })
}

// 研报详情
export const selectFileByid = params => {
    return request({
        method: 'POST',
        url: '/graphicallightweightdata/ms/selectFileByid',
        data: params
    })
}

// 获取左侧菜单
export const findNewReportsSimplify = params => {
    return request({
        method: 'POST',
        url: '/graphicallightweightdata/ms/findNewReportsSimplify',
        data: params
    })
}